module.exports = __webpack_public_path__ + "static/media/Gangplank.a883aa76.png";